// CUSTOM START: KI-Badge für KI-generierte Bilder
(() => {
  const MODAL_ID = 'custom-ai-badge-modal';
  const AI_MARKER = /_ki[_.]/;

  // Badge-Text NICHT aus diesem Asset lokalisieren: .js.liquid-Assets werden
  // von Shopify sprachneutral (global gecachte CDN-URL) mit der Shop-
  // Standardsprache gerendert — `| t` liefert dort immer EN. Stattdessen aus
  // dem pro Seite lokalisierten Modal-Snippet (data-badge-title) lesen.
  function getBadgeTitle() {
    return document.getElementById(MODAL_ID)?.dataset.badgeTitle || 'AI-Generated';
  }

  const EXCLUDE_SELECTOR = '.product-gallery__thumbnail-list, .product-gallery__thumbnail-scroller';

  // Findet den Container, an dem der Badge verankert wird — nebenwirkungsfrei.
  function findContainer(img) {
    const parent = img.parentElement;
    if (!parent) return null;
    // <picture display:contents> hat keine eigene Box — eine Ebene höher.
    // Normales <picture> (z.B. in image-with-text) hat eigene Box — als Container nutzen.
    const node = parent.tagName === 'PICTURE'
      ? (getComputedStyle(parent).display === 'contents' ? parent.parentElement : parent)
      : parent;
    return node || null;
  }

  // Soll-Zustand: Badge, wenn Container explizit markiert ist oder ein
  // tatsächlich angezeigtes KI-Bild enthält. Auf Produktkarten zählt nur das
  // Primärbild — das Sekundär-/Hover-Bild (aria-hidden) darf den Badge nicht
  // auslösen, wenn das sichtbare Bild kein KI-Bild ist.
  function containerShouldHaveBadge(container) {
    if (container.hasAttribute('data-ai-badge')) return true;
    const primary = container.querySelector('.product-card__image--primary');
    const imgs = primary ? [primary] : Array.from(container.querySelectorAll('img'));
    return imgs.some(
      (img) => !img.closest(EXCLUDE_SELECTOR) && AI_MARKER.test(img.src)
    );
  }

  function ensureBadge(container) {
    if (container.querySelector(':scope > .custom-ai-badge')) return;
    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'custom-ai-badge';
    btn.setAttribute('aria-controls', MODAL_ID);
    btn.setAttribute('aria-expanded', 'false');
    const span = document.createElement('span');
    span.textContent = getBadgeTitle();
    btn.appendChild(span);
    container.appendChild(btn);
  }

  function removeBadge(container) {
    const btn = container.querySelector(':scope > .custom-ai-badge');
    if (btn) btn.remove();
  }

  // Stellt den Soll-Zustand her (hinzufügen ODER entfernen) — idempotent.
  function reconcile(container) {
    if (!container) return;
    if (containerShouldHaveBadge(container)) {
      ensureBadge(container);
    } else {
      removeBadge(container);
    }
  }

  function reconcileForImg(img) {
    if (img.closest(EXCLUDE_SELECTOR)) return;
    reconcile(findContainer(img));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('img').forEach(reconcileForImg);
    document.querySelectorAll('[data-ai-badge]').forEach(reconcile);

    // Scrollbar-Kompensation: verhindert Layout-Shift beim Öffnen des Modals
    const modal = document.getElementById(MODAL_ID);
    if (modal) {
      modal.addEventListener('dialog:before-show', () => {
        const w = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--modal-scrollbar-compensation', `${w}px`);
      });
      modal.addEventListener('dialog:after-hide', () => {
        document.documentElement.style.removeProperty('--modal-scrollbar-compensation');
      });
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
          // src/srcset-Swap am selben <img> (Kontexte ohne Node-Replacement)
          if (mutation.target.tagName === 'IMG') reconcileForImg(mutation.target);
          continue;
        }
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IMG') {
            reconcileForImg(node);
          } else {
            node.querySelectorAll?.('img').forEach(reconcileForImg);
            if (node.hasAttribute?.('data-ai-badge')) reconcile(node);
            node.querySelectorAll?.('[data-ai-badge]').forEach(reconcile);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });
  });
})();
// CUSTOM END: KI-Badge für KI-generierte Bilder
